<script lang="ts">
	import type { DeviceButtonV2PropsTypes } from '@Shelly/shelly-design-system';
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];
	export let useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {
		size: 's',
	};

	$: actionStatus =
		statuses?.find((i) => /^(state)$/.test(i.role)) || statuses?.find((i) => i.hasAction);
</script>

{#if actionStatus?.id}
	<VirtualBooleanButton
		{device}
		{useV2Components}
		componentID={actionStatus.id}
		value={actionStatus.event}
		icon={actionStatus.icon || 'fa fa-power-off'}
		{deviceButtonV2Props}
	/>
{/if}
